import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PageFooter.css';
import { initScrollAnimations } from '../utils/scrollAnimations';

function PageFooter() {
  const [email, setEmail] = useState('');

  useEffect(() => {
    initScrollAnimations();
  }, []);

  const handleSubscribe = () => {
    if (!email) {
      alert('Please enter your email address');
      return;
    }
    
    console.log('Newsletter Subscription:', email);
    alert('Thank you for subscribing to our newsletter!');
    setEmail('');
  };

  return (
    <footer className="page-footer">
      <div className="footer-content">
        {/* Left Section - Brand */}
        <div className="footer-brand">
          <div className="footer-logo-container">
            <img src="/img/audit_icon.webp" alt="Song Audit Logo" className="footer-logo" />
          </div>
          <div className="footer-brand-text">
            <h3 className="footer-brand-title">SONG AUDIT</h3>
            <h4 className="footer-brand-subtitle">MUSIC CATALOG ANALYSIS</h4>
            <p className="footer-brand-description">Maximizing music revenue potential.</p>
          </div>
          
          {/* Social Icons */}
          <div className="footer-social-icons">
            <a 
              href="https://instagram.com/songaudit" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-social-icon"
            >
              <img src="/img/social.svg" alt="Instagram" />
            </a>
            <a 
              href="https://linkedin.com/company/songaudit" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-social-icon"
            >
              <img src="/img/link.svg" alt="LinkedIn" />
            </a>
          </div>
        </div>

        {/* Footer Links Grid */}
        <div className="footer-links-grid">
          {/* Contact Section */}
          <div className="footer-section">
            <h5 className="footer-section-title">CONTACT</h5>
            <ul className="footer-links">
              <li><a href="mailto:hey@orientanalytics.com">Email</a></li>
              <li><a href="tel:+43123456789">Phone</a></li>
              <li><Link to="/imprint">Imprint</Link></li>
            </ul>
          </div>

          {/* Services Section */}
          <div className="footer-section">
            <h5 className="footer-section-title">SERVICES</h5>
            <ul className="footer-links">
              <li><span className="footer-link-inactive">Catalog Audit</span></li>
              <li><span className="footer-link-inactive">Revenue Optimization</span></li>
              <li><span className="footer-link-inactive">Distribution Analysis</span></li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="footer-section">
            <h5 className="footer-section-title">LEGAL</h5>
            <ul className="footer-links">
              <li><Link to="/imprint">Imprint</Link></li>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Use</a></li>
            </ul>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="footer-newsletter">
          <h5 className="footer-newsletter-title">SUBSCRIBE TO NEWSLETTER</h5>
          <p className="footer-newsletter-description">
            Get updates about new features and music industry insights
          </p>
          
          <div className="newsletter-form">
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="newsletter-input"
            />
            <button 
              onClick={handleSubscribe}
              className="newsletter-button"
            >
              Subscribe
            </button>
          </div>
          
          <p className="newsletter-privacy">
            We respect your privacy. You can unsubscribe at any time.
          </p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          <p>© 2025 Song Audit - Music Catalog Analysis Platform. All rights reserved.</p>
          <p className="footer-slogan">Music connects. Revenue grows. We optimize.</p>
        </div>
      </div>
    </footer>
  );
}

export default PageFooter; 